import React from "react";
import { connect } from "react-redux";
import BreadCrumComponent from "../componentes/BreadCrumComponent";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import {
  getHistorial,
  getSaldo,
  asignarVacaciones,
  modificarVacaciones,
  cancelarVacaciones,
} from "./VacacionesService";

const formAsignarVacio = { dias: "", observaciones: "" };
const formEditarVacio = { dias: "", observaciones: "" };
const formCancelarVacio = { motivoCancelacion: "", devolverDias: false };

const BADGE = {
  VIGENTE: "badge-activo",
  CANCELADO: "badge-baja",
  USADO: "badge-neutro",
  SOLICITADO: "badge-pendiente",
  RECHAZADO: "badge-baja",
};

class VerVacaciones extends React.Component {
  constructor(props) {
    super(props);

    const legajoId =
      props?.match?.params?.legajoId ||
      props?.location?.state?.legajoId ||
      "";

    const nombreColaborador = props?.location?.state?.nombreColaborador || "";

    const navState = props?.location?.state;

    this.state = {
      legajoId,
      nombreColaborador,
      saldo: null,
      historial: [],
      cargando: true,
      mostrarMensajeFlash: navState?.mostrarMensajeFlash || false,
      mensajeFlash: navState?.mensajeFlash || "",
      mensajeFlashSeverity: navState?.mensajeFlashSeverity || "neutral",

      // modales
      modalAsignarAbierto: false,
      modalEditarAbierto: false,
      modalCancelarAbierto: false,

      seleccionado: null,
      formAsignar: { ...formAsignarVacio },
      formEditar: { ...formEditarVacio },
      formCancelar: { ...formCancelarVacio },

      guardando: false,
    };

    this.dialogAsignarRef = React.createRef();
    this.dialogEditarRef = React.createRef();
    this.dialogCancelarRef = React.createRef();
  }

  componentDidMount() {
    this.cargarDatos();
  }

  componentDidUpdate(prevProps, prevState) {
    this.sincronizarModal("dialogAsignarRef", "modalAsignarAbierto", prevState, this.cerrarAsignar);
    this.sincronizarModal("dialogEditarRef", "modalEditarAbierto", prevState, this.cerrarEditar);
    this.sincronizarModal("dialogCancelarRef", "modalCancelarAbierto", prevState, this.cerrarCancelar);
  }

  sincronizarModal = (refName, stateKey, prevState, onClose) => {
    const ref = this[refName];
    if (this.state[stateKey] && !prevState[stateKey]) {
      ref.current?.showModal();
    } else if (!this.state[stateKey] && prevState[stateKey]) {
      if (ref.current?.open) ref.current.close();
    }
  };

  cargarDatos = async () => {
    const { legajoId } = this.state;
    if (!legajoId) {
      this.setState({ cargando: false });
      return;
    }
    try {
      const [saldoRes, historialRes] = await Promise.all([
        getSaldo(legajoId),
        getHistorial(legajoId),
      ]);
      this.setState({
        cargando: false,
        saldo: saldoRes.data?.datos ?? 0,
        historial: historialRes.data?.datos || [],
      });
    } catch {
      this.setState({ cargando: false });
      this.flash("No se pudo cargar el historial de vacaciones.", "error");
    }
  };

  formatDate = (value) => {
    if (!value) return "--";
    return new Date(value).toLocaleDateString("es-PY");
  };

  flash = (mensaje, severity) =>
    this.setState({ mostrarMensajeFlash: true, mensajeFlash: mensaje, mensajeFlashSeverity: severity });

  // ======================
  // Modal Asignar
  // ======================
  abrirAsignar = () =>
    this.setState({ modalAsignarAbierto: true, formAsignar: { ...formAsignarVacio } });

  cerrarAsignar = () =>
    this.setState({ modalAsignarAbierto: false, formAsignar: { ...formAsignarVacio } });

  handleAsignar = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({ formAsignar: { ...prev.formAsignar, [name]: value } }));
  };

  confirmarAsignar = async () => {
    const { formAsignar, legajoId } = this.state;
    if (!formAsignar.dias || parseInt(formAsignar.dias) <= 0) {
      this.flash("La cantidad de días debe ser mayor a 0", "error");
      return;
    }
    this.setState({ guardando: true });
    try {
      const payload = {
        dias: parseInt(formAsignar.dias),
        observaciones: formAsignar.observaciones.trim() || null,
      };
      const res = await asignarVacaciones(legajoId, payload);
      this.setState({ guardando: false, modalAsignarAbierto: false });
      this.flash(res.data?.mensaje || "Vacaciones asignadas correctamente", res.data?.error ? "error" : "exito");
      this.cargarDatos();
    } catch (e) {
      this.setState({ guardando: false });
      this.flash(e?.response?.data?.mensaje || "No se pudo asignar las vacaciones", "error");
    }
  };

  // ======================
  // Modal Editar
  // ======================
  abrirEditar = (item) =>
    this.setState({
      modalEditarAbierto: true,
      seleccionado: item,
      formEditar: { dias: item.dias, observaciones: item.observaciones || "" },
    });

  cerrarEditar = () =>
    this.setState({ modalEditarAbierto: false, seleccionado: null, formEditar: { ...formEditarVacio } });

  handleEditar = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({ formEditar: { ...prev.formEditar, [name]: value } }));
  };

  confirmarEditar = async () => {
    const { formEditar, seleccionado } = this.state;
    if (!formEditar.dias || parseInt(formEditar.dias) <= 0) {
      this.flash("La cantidad de días debe ser mayor a 0", "error");
      return;
    }
    this.setState({ guardando: true });
    try {
      const payload = { dias: parseInt(formEditar.dias), observaciones: formEditar.observaciones || null };
      const res = await modificarVacaciones(seleccionado.id, payload);
      this.setState({ guardando: false, modalEditarAbierto: false });
      this.flash(res.data?.mensaje || "Guardado correctamente", res.data?.error ? "error" : "exito");
      this.cargarDatos();
    } catch (e) {
      this.setState({ guardando: false });
      this.flash(e?.response?.data?.mensaje || "No se pudo guardar", "error");
    }
  };

  // ======================
  // Modal Cancelar
  // ======================
  abrirCancelar = (item) =>
    this.setState({ modalCancelarAbierto: true, seleccionado: item, formCancelar: { ...formCancelarVacio } });

  cerrarCancelar = () =>
    this.setState({ modalCancelarAbierto: false, seleccionado: null, formCancelar: { ...formCancelarVacio } });

  handleCancelar = (e) => {
    const { name, type, value, checked } = e.target;
    this.setState((prev) => ({
      formCancelar: { ...prev.formCancelar, [name]: type === "checkbox" ? checked : value },
    }));
  };

  confirmarCancelacion = async () => {
    const { seleccionado, formCancelar } = this.state;
    if (!formCancelar.motivoCancelacion?.trim()) {
      this.flash("El motivo de cancelación es requerido", "error");
      return;
    }
    this.setState({ guardando: true });
    try {
      const res = await cancelarVacaciones(seleccionado.id, formCancelar);
      this.setState({ guardando: false, modalCancelarAbierto: false });
      this.flash(res.data?.mensaje || "Cancelado correctamente", res.data?.error ? "error" : "exito");
      this.cargarDatos();
    } catch (e) {
      this.setState({ guardando: false });
      this.flash(e?.response?.data?.mensaje || "No se pudo cancelar", "error");
    }
  };

  // ======================
  // Render historial
  // ======================
  renderHistorial = () => {
    const { historial } = this.state;

    if (historial.length === 0) {
      return <p className="empty-section">No hay movimientos registrados.</p>;
    }

    return (
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>Días</th>
              <th>Estado</th>
              <th>Fecha asignación</th>
              <th>Observaciones</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {historial.map((v) => (
              <tr key={v.id}>
                <td>{v.estado === "USADO" ? `-${v.dias}` : `+${v.dias}`}</td>
                <td>
                  <span className={`badge-estado ${BADGE[v.estado] || "badge-neutro"}`}>
                    {v.estado}
                  </span>
                </td>
                <td>{this.formatDate(v.fechaAsignacion)}</td>
                <td>
                  {v.estado === "CANCELADO" && v.motivoCancelacion
                    ? v.motivoCancelacion
                    : v.observaciones || "--"}
                </td>
                <td>
                  <div className="table-actions">
                    {v.estado === "VIGENTE" && (
                      <button
                        className="table-icon"
                        title="Modificar"
                        onClick={() => this.abrirEditar(v)}
                      >
                        <span className="material-symbols-outlined">edit</span>
                      </button>
                    )}
                    {(v.estado === "VIGENTE" || v.estado === "USADO") && (
                      <button
                        className="table-icon"
                        title="Cancelar y devolver días"
                        onClick={() => this.abrirCancelar(v)}
                      >
                        <span className="material-symbols-outlined">cancel</span>
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  // ======================
  // Render modales
  // ======================
  renderModalAsignar = () => {
    const { formAsignar, guardando } = this.state;
    return (
      <div className="component-modal">
        <dialog className="modal" ref={this.dialogAsignarRef} onClose={this.cerrarAsignar}>
          <div className="modal-content">
            <div className="modal-head">
              <h4 className="modal-title">Asignar días de vacaciones</h4>
              <div className="actions">
                <button className="btn-medium btn-circle-icon btn-primary-tonal" onClick={this.cerrarAsignar}>
                  <span className="material-symbols-outlined">close</span>
                </button>
              </div>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <input
                  className="form-input"
                  type="number"
                  name="dias"
                  min="1"
                  placeholder=" "
                  value={formAsignar.dias}
                  onChange={this.handleAsignar}
                />
                <label className="form-label">Días a asignar *</label>
              </div>
              <div className="form-group">
                <textarea
                  className="form-textarea"
                  name="observaciones"
                  rows={3}
                  placeholder=" "
                  value={formAsignar.observaciones}
                  onChange={this.handleAsignar}
                />
                <label className="form-label-textarea">Observaciones</label>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn-medium btn-base-outline" onClick={this.cerrarAsignar}>
                Cancelar
              </button>
              <button className="btn-medium btn-primary" onClick={this.confirmarAsignar} disabled={guardando}>
                {guardando ? "Guardando..." : "Asignar"}
              </button>
            </div>
          </div>
        </dialog>
      </div>
    );
  };

  renderModalEditar = () => {
    const { formEditar, seleccionado, guardando } = this.state;
    return (
      <div className="component-modal">
        <dialog className="modal" ref={this.dialogEditarRef} onClose={this.cerrarEditar}>
          <div className="modal-content">
            <div className="modal-head">
              <h4 className="modal-title">Modificar asignación</h4>
              <div className="actions">
                <button className="btn-medium btn-circle-icon btn-primary-tonal" onClick={this.cerrarEditar}>
                  <span className="material-symbols-outlined">close</span>
                </button>
              </div>
            </div>
            <div className="modal-body">
              {seleccionado && (
                <div className="card mb-2">
                  <div className="card-info">
                    <span className="label">Días actuales</span>
                    <span className="txt">{seleccionado.dias}</span>
                  </div>
                </div>
              )}
              <div className="form-group">
                <input
                  className="form-input"
                  type="number"
                  name="dias"
                  min="1"
                  placeholder=" "
                  value={formEditar.dias}
                  onChange={this.handleEditar}
                />
                <label className="form-label">Días *</label>
              </div>
              <div className="form-group">
                <textarea
                  className="form-textarea"
                  name="observaciones"
                  rows={3}
                  placeholder=" "
                  value={formEditar.observaciones}
                  onChange={this.handleEditar}
                />
                <label className="form-label-textarea">Observaciones</label>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn-medium btn-base-outline" onClick={this.cerrarEditar}>
                Cancelar
              </button>
              <button className="btn-medium btn-primary" onClick={this.confirmarEditar} disabled={guardando}>
                {guardando ? "Guardando..." : "Guardar"}
              </button>
            </div>
          </div>
        </dialog>
      </div>
    );
  };

  renderModalCancelar = () => {
    const { seleccionado, formCancelar, guardando } = this.state;
    const esUsado = seleccionado?.estado === "USADO";

    return (
      <div className="component-modal">
        <dialog className="modal" ref={this.dialogCancelarRef} onClose={this.cerrarCancelar}>
          <div className="modal-content">
            <div className="modal-head">
              <h4 className="modal-title">
                {esUsado ? "Anular uso de vacaciones" : "Cancelar asignación"}
              </h4>
              <div className="actions">
                <button className="btn-medium btn-circle-icon btn-primary-tonal" onClick={this.cerrarCancelar}>
                  <span className="material-symbols-outlined">close</span>
                </button>
              </div>
            </div>
            <div className="modal-body">
              {seleccionado && (
                <div className="card mb-2">
                  <div className="card-info">
                    <span className="label">Días</span>
                    <span className="txt">{seleccionado.dias}</span>
                  </div>
                  {esUsado && (
                    <div className="card-info">
                      <span className="label">Efecto</span>
                      <span className="txt">Se devolverán {seleccionado.dias} días al saldo disponible</span>
                    </div>
                  )}
                </div>
              )}
              <div className="form-group">
                <textarea
                  className="form-textarea"
                  name="motivoCancelacion"
                  rows={3}
                  placeholder=" "
                  value={formCancelar.motivoCancelacion}
                  onChange={this.handleCancelar}
                />
                <label className="form-label-textarea">Motivo *</label>
              </div>
              {!esUsado && (
                <div className="form-group__inline">
                  <input
                    type="checkbox"
                    className="form-check"
                    name="devolverDias"
                    id="devolverDias"
                    checked={formCancelar.devolverDias}
                    onChange={this.handleCancelar}
                  />
                  <label className="check-label" htmlFor="devolverDias">
                    Devolver días al saldo
                  </label>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn-medium btn-base-outline" onClick={this.cerrarCancelar}>
                Volver
              </button>
              <button className="btn-medium btn-primary" onClick={this.confirmarCancelacion} disabled={guardando}>
                {guardando ? "Procesando..." : "Confirmar"}
              </button>
            </div>
          </div>
        </dialog>
      </div>
    );
  };

  render() {
    const { saldo, cargando, nombreColaborador, mostrarMensajeFlash, mensajeFlash, mensajeFlashSeverity, guardando } = this.state;

    return (
      <div>
        <div className="template-base">
          <header className="component-header">
            <div className="page-container">
              <BreadCrumComponent
                backUrl="/administracion/vacaciones"
                breadcrumbs={[
                  { label: "Vacaciones", path: "/administracion/vacaciones" },
                  { label: nombreColaborador || "Movimientos" },
                ]}
              />

              <div className="head-area">
                <div className="caption-area">
                  <h1 className="page-title">
                    {nombreColaborador || "Colaborador"}
                  </h1>
                  {saldo !== null && (
                    <p className="page-description">
                      Saldo disponible: <strong>{saldo} días</strong>
                    </p>
                  )}
                </div>
                <div className="head-actions">
                  <button className="btn-medium btn-primary" onClick={this.abrirAsignar}>
                    <span className="material-symbols-outlined">add</span>
                    Asignar días
                  </button>
                </div>
              </div>
            </div>
          </header>

          <div className="wrapperContent">
            <div className="page-container">
              {cargando ? (
                <p className="empty-section">Cargando...</p>
              ) : (
                <div className="card">
                  <h3 className="form-subtitle">Movimientos de vacaciones</h3>
                  {this.renderHistorial()}
                </div>
              )}
            </div>
          </div>
        </div>

        {this.renderModalAsignar()}
        {this.renderModalEditar()}
        {this.renderModalCancelar()}

        <MensajeFlash
          visible={mostrarMensajeFlash}
          mensaje={mensajeFlash}
          severity={mensajeFlashSeverity}
        />
        <PantallaCarga open={guardando} />
      </div>
    );
  }
}

export default connect(null, null)(VerVacaciones);
